import { hero1Image, hero1MobileImage } from "../images";

export const heroData = [
	{
		imageSource: [hero1Image, hero1MobileImage],
		// heading: "Contact Us",
	},
];

export const welcomeData = [
	{
		// imageSource: educationImage,
		description: [
			"Integrated learning approach to develop the intellectual,	emotional, moral, social and physical well-being of community members.",
			"“By education, I mean an all-round drawing of the best in child and man in body, mind and spirit” Mahatma Gandhi",
		],
	},
];
